import { Directive, TemplateRef, inject } from '@angular/core';
import { LiberroDisclaimerComponent } from '../liberro-disclaimer/liberro-disclaimer.component';

@Directive({ selector: '[liberroDisclaimerSlide]', standalone: false })
export class DisclaimerSlideDirective {
  public readonly templateRef = inject<TemplateRef<LiberroDisclaimerComponent>>(TemplateRef);
}